<template>
  <div
      class="stories-main-wrapper">
    <div ref="wrapperContent" class="stories-main-wrapper__content">
      <StoriesMainSlider @close="closeStories" :stories="stories" :story-index="storyIndex" ref="storiesMainSlider"/>
    </div>
  </div>
</template>

<script setup>
import {defineEmits, ref} from 'vue';
import StoriesMainSlider from './StoriesMainSlider.vue';
import {defineProps} from "vue";

const props = defineProps(['stories', 'storyIndex']);
const emit = defineEmits(['close'])


const stories = props.stories;
const wrapperContent = ref(null);
const storiesMainSlider = ref(null);

const closeStories = () => {
  emit('close', {index: null, isStoriesActive: false})
}

const closeStoriesHandler = (e) => {

  const storiesSlider = storiesMainSlider.value?.$refs.storiesMainSlider.$el;
  const storiesSliderWrapper = storiesMainSlider.value?.$refs.storiesMainSlider.$el.firstElementChild;

  e.target === wrapperContent.value ||
  e.target === storiesSlider ||
  e.target === storiesSliderWrapper
      ? closeStories()
      : false;
};

</script>

<style scoped>
.stories-main-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.3);
  height: 100%;
}

.stories-main-wrapper__content {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  overflow: hidden;
}
</style>